import { create } from 'zustand';
import { persistForUser } from '@erikdakoda/ui/shared/persistForUser';
import type {
  GridColumnVisibilityModel,
  GridFilterModel,
  GridPaginationModel,
  GridSortModel,
} from '@mui/x-data-grid-pro';

type ToolSetGridState = {
  paginationModel: GridPaginationModel;
  sortModel: GridSortModel;
  filterModel: GridFilterModel;
  columnVisibilityModel: GridColumnVisibilityModel;
  quickFilterValue: string;
  editedToolSetId: string | null;
  setPaginationModel: (model: GridPaginationModel) => void;
  setSortModel: (model: GridSortModel) => void;
  setFilterModel: (model: GridFilterModel) => void;
  setColumnVisibilityModel: (model: GridColumnVisibilityModel) => void;
  setQuickFilterValue: (value: string) => void;
  setEditedToolSetId: (id: string | null) => void;
};

export const useToolSetGridStore = create<ToolSetGridState>()(
  persistForUser(
    (set) => ({
      paginationModel: { page: 0, pageSize: 25 },
      sortModel: [{ field: 'name', sort: 'asc' }],
      filterModel: { items: [] },
      columnVisibilityModel: { id: false },
      quickFilterValue: '',
      editedToolSetId: null,
      setPaginationModel: (paginationModel) => set({ paginationModel }),
      setSortModel: (sortModel) => set({ sortModel }),
      setFilterModel: (filterModel) => set({ filterModel }),
      setColumnVisibilityModel: (columnVisibilityModel) => set({ columnVisibilityModel }),
      setQuickFilterValue: (quickFilterValue) => set({ quickFilterValue }),
      setEditedToolSetId: (editedToolSetId) => set({ editedToolSetId }),
    }),
    {
      name: 'toolSet-grid-store',
      partialize: (state) =>
        Object.fromEntries(
          Object.entries(state).filter(([key]) => !['editedToolSetId'].includes(key)),
        ),
    },
  ),
);
